import { Model, belongsTo } from 'miragejs'

export default Model.extend({
  book: belongsTo('book-library/book'),
})
